import { useMutation, useQuery } from "react-query";
import { PSLService } from "./psl.service";
import { CompetitiveBiddingService } from "../../competitiveBidding/domains/cb.service";
import { CurrencyData } from "../../competitiveBidding/domains/selector/currency";
import { ICatRow } from "./pslMaterial";

export const useFetchSpendCategories = () => {
  return useQuery("categoryTree", () => PSLService.fetchCategoryTree(), {
    staleTime: Infinity
  });
};

export const useFetchCurrencies = () => {
  return useQuery(
    "currencies",
    () =>
      CompetitiveBiddingService.fetchCurrencies().then((res: CurrencyData[]) =>
        res.map(CurrencyData.toSelect)
      ),
    { staleTime: Infinity }
  );
};

export const useFetchAllCurrencies = () => {
  return useQuery("AllCurrencies", () => PSLService.fetchAllCurrencies(), {
    staleTime: Infinity
  });
};

export const useFetchPslCatalogs = (query: any, userScope) => {
  return useQuery(
    "pslCatalogs" + JSON.stringify(query),
    () => PSLService.fetchMaterials_PslCatalogs(query, userScope),
    { staleTime: Infinity, retry: 2 }
  );
};

export const usePslFavToggle = () =>
  useMutation((pslId: number) => PSLService.updateFavouriteToggle(pslId));

export const useSavePslCatalogsFilters = () => {
  return useMutation((filters: any) =>
    PSLService.savePslCatalogsFilters(filters)
  );
};

export const useSaveCopiedItem = (
  refetchData,
  onClose,
  setSuccessMessage,
  setErrorMessage,
  deleteItem = false
) => {
  return useMutation(
    (mrpAutonomousSourcingData: any) =>
      PSLService.updatePslVendorWithMaterials(mrpAutonomousSourcingData),
    {
      onSuccess: () => {
        refetchData();
        onClose();
        setSuccessMessage(
          deleteItem ? "Item has been deleted" : "Item has been saved"
        );
      },
      onError: (e: any) => {
        if(typeof e === 'string') {
          setErrorMessage(e);
        }else{
          setErrorMessage(e?.message);
        }
      }
    }
  );
};

export const useGetMaterialItems = setErrorMessage => {
  return useMutation(
    ({
      pslId,
      skip = 0,
      take = 10,
      spendCategoryId,
      materialSearch
    }: {
      pslId: number;
      skip: number;
      take: number;
      spendCategoryId?: number;
      materialSearch?: any;
    }) =>
      PSLService.fetchNewMaterialsByPslId(
        pslId,
        skip,
        take,
        spendCategoryId,
        materialSearch
      ),
    {
      onError: (e: any) => {
        setErrorMessage(e?.message);
      }
    }
  );
};

export const useFetchSuppierHistoryData = (
  pslID: string,
  skip: number,
  take: number,
  isItSuppplierTab: boolean
) => {
  return useQuery(
    "PslSupplierHistory" + pslID + skip + take,
    () => PSLService.fetchPslSupplierHistory(pslID, skip, take),
    { enabled: isItSuppplierTab, staleTime: Infinity, retry: 2 }
  );
};

export const useFetchMaterialHistoryData = (
  pslID: string,
  materialId: string,
  skip: number,
  take: number,
  isItSuppplierTab: boolean
) => {
  return useQuery(
    "PslSMaterialHistory" + pslID + materialId + skip + take,
    () => PSLService.fetchPslMaterialHistory(pslID, materialId, skip, take),
    { enabled: isItSuppplierTab, staleTime: Infinity, retry: 2 }
  );
};
export const useFetchkeywordsHistoryData = (
  pslID: string,
  materialId: string,
  skip: number,
  take: number,
  isItSuppplierTab: boolean
) => {
  return useQuery(
    "PslKeywordsHistory" + pslID + materialId + skip + take,
    () => PSLService.fetchPslKeywordsHistory(pslID, materialId, skip, take),
    { enabled: isItSuppplierTab, staleTime: Infinity, retry: 2 }
  );
};
